<template>
  <div class="grid-x" id="app-topbar">
    <!-- Logo -->
    <router-link to="/" id="topbar-logo" class="cell shrink grid-x align-center align-middle">
      <img src="@/assets/logo.svg" alt="horstCOSMOS Logo" loading="lazy" />
    </router-link>

    <!-- Desktop Elements -->
    <div class="lang">
      <a href="#" id="de" @click="handleLanguage" :class="$i18n.locale === 'de' && 'selected'">DE</a>
      <a href="#" id="en" @click="handleLanguage" :class="$i18n.locale === 'en' && 'selected'">EN</a>
    </div>
    <topbar-user-component id="topbar-user" class="cell shrink" />
  </div>
</template>

<script lang="ts">
import { uiOptions } from '@/config'
import { defineComponent, computed } from 'vue'
import TopbarUserComponent from './TopbarUserComponent.vue'
import { useI18n } from 'vue-i18n'
import { enLocationOptions, deLocationOptions } from '@/config'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'Topbar',
  components: {
    TopbarUserComponent
  },

  setup() {
    const ui = uiOptions()
    const i18n = useI18n()
    const route = useRoute()

    const handleLanguage = (e: Event) => {
      const langSelected = e.target as HTMLElement
      switch (langSelected.id) {
        case 'de':
          i18n.locale.value = 'de'
          ui.changeLanguageLocationOptions(deLocationOptions)
          break
        case 'en':
          i18n.locale.value = 'en'
          ui.changeLanguageLocationOptions(enLocationOptions)
          break
        default:
          i18n.locale.value = 'en'
          ui.changeLanguageLocationOptions(enLocationOptions)
          break
      }
    }

    return {
      handleLanguage,
    }
  },
})
</script>

<style lang="scss">
#app-topbar {
  height: 3.75rem;
  min-height: 3.75rem;
  background-color: $light-gray;
  color: $medium-gray;
  position: relative;
  z-index: 1000;
  display: flex;
  align-items: center;
}

.lang {
  margin: auto;
  margin-right: 0.7vw;

  a {
    font-weight: bold;
    margin-inline: 0.2vw;
    color: $medium-gray;

    &.selected {
      color: $petrol;
    }
  }
}

#topbar-logo {
  padding-left: 2rem;
}
</style>
